import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LogOutIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 0 2H5Z" />
    <path d="M15.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H8.929C8.416 13 8 12.552 8 12s.416-1 .929-1h9.657l-3.293-3.293a1 1 0 0 1 0-1.414Z" />
  </Icon>
));
export default LogOutIcon;
